import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

export const NavigationLink = ({ to, title, icon, setMenuOpen }) => (
  <NavLink to={to} onClick={() => setMenuOpen(false)}>
    <i className={`fa fa-${icon}`}></i>
    {title}
  </NavLink>
);
NavigationLink.displayName = "NavigationLink";
NavigationLink.propTypes = {
  to: PropTypes.string,
  title: PropTypes.string,
  icon: PropTypes.string,
  setMenuOpen: PropTypes.func,
};
